import PropTypes from 'prop-types'
import { Component } from 'react'

import StickyHeader from 'components/sticky-header'
import PostLink from '../post-link'

export default class PostNavBar extends Component {
  static propTypes = {
    hideTitle: PropTypes.bool,
    nextPost: PropTypes.object,
    minimalView: PropTypes.bool,
    previousPost: PropTypes.object,
    shareProps: PropTypes.object,
    title: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
      .isRequired,
  }

  previousPostButton = () =>
    this.props.previousPost ? (
      <PostLink
        className="hidden-xs"
        direction="left"
        post={this.props.previousPost}
      />
    ) : null

  nextPostButton = () =>
    this.props.nextPost ? (
      <div className="hidden-xs full-width text-right">
        <PostLink direction="right" post={this.props.nextPost} />
      </div>
    ) : null

  render() {
    const { children, title, hideTitle, minimalView } = this.props
    return (
      <StickyHeader
        hideTitle={minimalView}
        leftActionComponent={<>{this.previousPostButton()}</>}
        rightActionComponent={this.nextPostButton()}
        title={title}
      >
        {children}
      </StickyHeader>
    )
  }
}
